import { COL, PESTANAS, TABS, TODAS } from './columnas';
import { columnasPm } from './columnasPm';

export const FORMATO_PF = {
  tipo: 'pf', nombre: 'PF', archivo: 'CSV', extension: 'csv', resultado: '58',
  inicial: 'persona', ajustes: true, col: COL, tabs: TABS, todas: TODAS, pestanas: PESTANAS,
};
export const FORMATO_PM = {
  tipo: 'pm_pfae', nombre: 'PM y PFAE', archivo: 'TXT', extension: 'txt', resultado: '3019',
  inicial: 'empresa', ajustes: false,
};
export const formatoDe = (reporte) => reporte?.tipo === 'pm_pfae'
  ? { ...FORMATO_PM, ...columnasPm(reporte.campos || []) }
  : FORMATO_PF;
